import React, {useContext, useState} from 'react';
import { sendEmailVerification } from 'firebase/auth';
import FormElement from '../components/FormElement';

import '../style/styles.scss';
import {AccountContext} from "../context/Accounts";
import {useHistory} from "react-router-dom";

export default () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const history = useHistory();

  const {register} = useContext(AccountContext);

  const signUp = async (event) => {
    event.preventDefault();
    setMessage('');
    setIsError(false);

    try {
      const userCredential = await register(email, password);
      console.log('User registered:', userCredential);

      // Send email verification
      await sendEmailVerification(userCredential.user);

      setMessage('Account created successfully! A verification email has been sent to your inbox.');
      setIsError(false);

      // Automatically log in the user after successful signup
      setTimeout(() => {
        history.push('/dashboard');
      }, 2000);

    } catch (error) {
      console.error('Signup error:', error);
      console.error('Error code:', error?.code);
      console.error('Error message:', error?.message);
      setIsError(true);

      // Handle specific Firebase error codes
      if (!error || !error.code) {
        setMessage('Error: Firebase Authentication may not be enabled. Check Firebase Console > Authentication > Sign-in method > Enable Email/Password');
      } else {
        switch (error.code) {
          case 'auth/email-already-in-use':
            setMessage('This email is already registered. Please login instead.');
            break;
          case 'auth/invalid-email':
            setMessage('Invalid email address.');
            break;
          case 'auth/weak-password':
            setMessage('Password is too weak. Please use at least 6 characters.');
            break;
          case 'auth/operation-not-allowed':
            setMessage('Email/Password authentication is not enabled in Firebase Console. Please enable it first.');
            break;
          default:
            setMessage(error.message || `Error (${error.code}): An error occurred during signup.`);
        }
      }
    }
  };

  return (
    <div className="login">
      <h2>Sign up</h2>

      {message && (
        <div style={{
          padding: '10px',
          marginBottom: '15px',
          borderRadius: '4px',
          backgroundColor: isError ? '#ffebee' : '#e8f5e9',
          color: isError ? '#c62828' : '#2e7d32',
          border: `1px solid ${isError ? '#ef9a9a' : '#81c784'}`
        }}>
          {message}
        </div>
      )}

      <form onSubmit={signUp}>
        <FormElement label="Email" forId="sign-up-email">
          <input
            id="sign-up-email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="email"
            required
          />
        </FormElement>
        <FormElement label="Password" forId="sign-up-password">
          <input
            id="sign-up-password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="password (min 6 characters)"
            minLength="6"
            required
          />
        </FormElement>
        <p>
          <button type='submit'>Sign up</button>
        </p>
        <p style={{fontSize: '0.9em', color: '#666'}}>
          Already have an account? <a href="/login">Login here</a>
        </p>
      </form>
    </div>
  );
};
